// extracted by mini-css-extract-plugin
export var buttonContainer = "_4r-1";
export var fontSizeSelect = "_4r-3";
export var formatSelect = "_4r-2";
export var formats = "_4r-4";
export var hidden = "_4r-5";
export var icon = "_4r-6";
export var select = "_4r-0";